"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductDashboardMetadata = void 0;
class ProductDashboardMetadata {
}
exports.ProductDashboardMetadata = ProductDashboardMetadata;
//# sourceMappingURL=product-dashboard-metadata.response.js.map